'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$9() {
  this.aAq = null;
  this.aAr = false;
}
export { $c_Lpresto_AgentView$$anon$9 as $c_Lpresto_AgentView$$anon$9 };
$p = $c_Lpresto_AgentView$$anon$9.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$9;
/** @constructor */
function $h_Lpresto_AgentView$$anon$9() {
}
export { $h_Lpresto_AgentView$$anon$9 as $h_Lpresto_AgentView$$anon$9 };
$h_Lpresto_AgentView$$anon$9.prototype = $p;
$p.bW = (function() {
  if ((!this.aAr)) {
    this.aAq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.aAr = true;
  }
  return this.aAq;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_AgentView$$anon$9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$9, "presto.AgentView$$anon$9", ({
  Ee: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_AgentView$$anon$9 as $d_Lpresto_AgentView$$anon$9 };
//# sourceMappingURL=presto.-Agent-View$$anon$9.js.map
